// https://medium.com/better-programming/generate-contrasting-text-for-your-random-background-color-ac302dc87b4
const rgbToYIQ = ({ r, g, b }) => (r * 299 + g * 587 + b * 114) / 1000

const hexToRgb = hex => {
  if (!hex || hex === undefined || hex === "") {
    return undefined
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : undefined
}

export const isDarkTextColor = (colorHex, options = {}) => {
  const threshold = options.threshold || 150

  if (colorHex === undefined) {
    return true
  }

  const rgb = hexToRgb(colorHex)

  if (rgb === undefined) {
    return true
  }

  return rgbToYIQ(rgb) >= threshold
}

export default (colorHex, options = {}) => {
  const _options = { threshold: 150, black: "#000", white: "#fff", ...options }

  return isDarkTextColor(colorHex, _options) ? _options.black : _options.white
}
